import { LoaderFunction } from 'react-router-dom';
import { client } from '../../../../gql/client';
import { FETCH_TENANTS, APP_CONFIG_FOR_TENANT } from '../../../../gql/queries/admin';
import { AuthContextType } from '../../../../hooks/useAuth';

export const TenantDetailLoader: (
  userData: AuthContextType | null
) => LoaderFunction | undefined =
  (userData) =>
  async ({ params }) => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
    if (!userData || !params.tenantId) {
      return { tenant: null, configs: {} };
    }

    const tenantId = params.tenantId;

    // Fetch tenants list and configs (RAW settings, sin mergear con
    // defaults) in parallel. appConfigForTenant.settings solo contiene
    // los overrides reales del tenant — necesario para que hasOverride
    // detecte el origen correctamente (getAllConfigsForTenant devuelve
    // el mapa FUSIONADO defaults+overrides y siempre aparenta override).
    const [tenantsResult, appConfigResult] = await Promise.all([
      client.query({
        query: FETCH_TENANTS,
        fetchPolicy: 'cache-first',
      }),
      client.query({
        query: APP_CONFIG_FOR_TENANT,
        variables: { tenantId },
        fetchPolicy: 'network-only',
      }),
    ]);

    const tenant = tenantsResult.data?.tenants?.find(
      (t: { id: string }) => t.id === tenantId
    );

    // settings es un scalar JSON — normalmente llega ya como objeto, pero
    // se defiende el caso de que llegue serializado como string
    const rawSettings = appConfigResult.data?.appConfigForTenant?.settings;
    let configs: Record<string, string> = {};
    if (rawSettings && typeof rawSettings === 'object') {
      configs = rawSettings;
    } else if (typeof rawSettings === 'string') {
      try {
        configs = JSON.parse(rawSettings);
      } catch {
        configs = {};
      }
    }

    return {
        tenant: tenant || null,
        configs,
      };
  };

  return { data: load() };
};
